import ScheduledAlert from '../models/scheduledAlert';
import { excuseApi } from '../commons/http';

export const getScheduledAlerts = async (params) => {
  const res = await excuseApi({
    path: '/scheduled-alerts',
    method: 'GET',
    params,
  });
  return res.data;
};

export const getScheduledAlert = async (id) => {
  const res = await excuseApi({
    path: `/scheduled-alerts/${id}`,
    method: 'GET',
  });
  const alert = new ScheduledAlert();
  alert.mapData(res.data.data);
  return alert;
};

export const createScheduledAlert = async (data) => {
  const res = await excuseApi({
    path: '/scheduled-alerts',
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const updateScheduledAlert = async (id, data) => {
  const res = await excuseApi({
    path: `/scheduled-alerts/${id}`,
    method: 'PUT',
    body: data,
  });
  return res.data;
};

export const deleteScheduledAlert = async (id) => {
  const res = await excuseApi({
    path: `/scheduled-alerts/${id}`,
    method: 'DELETE',
  });
  return res.data;
};
